import { useEffect, useState } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { BeatLoader } from 'react-spinners';

import { fetchSupportTeamData } from '../../utils/fetchSupportTeamData';

import { SupportTeamData } from './supportTypes';
import './SupportTeam.css';

const DRIVE_FILE_ID = '1teXB5BRNuHfsiXaCh-qKuaspyxORsp73';

const SupportTeam = () => {
  const [supportData, setSupportData] = useState<SupportTeamData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSupportData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchSupportTeamData(DRIVE_FILE_ID);
        setSupportData(data);
      } catch (error) {
        console.error('Failed to load support team data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSupportData();
  }, []);

  return (
    <div className="support-card">
      <div className="d-flex align-items-center mb-3">
        <FontAwesomeIcon icon={faUsers} className="support-card-icon me-2" />
        <h3 className="mb-0">Support Team</h3>
      </div>

      {isLoading ? (
        <div className="text-center my-5">
          <BeatLoader color="#0d6efd" size={15} margin={2} />
        </div>
      ) : (
        <Row>
          <Col>
            <Table hover responsive className="support-team-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                {supportData?.members.map((member, index) => (
                  <tr
                    key={index}
                    className={member.active ? 'table-active' : undefined}
                  >
                    <td>{member.name}</td>
                    <td>{member.designation}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default SupportTeam;
